import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class DuplicatePaymentMethodError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.fiscalization.validation.payment-method-id.duplicates');
    }
}
